import { render, staticRenderFns } from "./collect_payment.vue?vue&type=template&id=18255d40&"
import script from "./collect_payment.vue?vue&type=script&lang=js&"
export * from "./collect_payment.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports